import { Component, OnInit, ViewChild } from '@angular/core';
 
import { FactureService } from 'src/app/service/facture.service';
import { Client } from 'src/app/entity/exhibitor';
import { Facture } from 'src/app/entity/Facture';
import { Pjoint } from 'src/app/entity/Pjoint';
import { ActivatedRoute } from '@angular/router';
import { ClientService } from 'src/app/service/client.service';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
 import { ContactService } from 'src/app/service/contact.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-facture-list',
  templateUrl: './facture-list.component.html',
  styleUrls: ['./facture-list.component.css']
})
export class FactureListComponent implements OnInit {
  
  idClient: number;
  client: Client;
  contratPdf = "";
  invoices: Facture[];
  selectedInvoice: Facture;
  pjoints: Pjoint[];
  dataSource: MatTableDataSource<Facture>;
  displayedColumns: string[] = ['numeroFiche', 'date', 'ttc'];
  editVisible: boolean;
  idfacture: number;
 
 
  constructor(private route: ActivatedRoute, private factureService: FactureService,private contactService: ContactService,
    private paticipantService: ExhibitorService, private clientService: ClientService) { }

  ngOnInit() {

  
    this.route.paramMap.subscribe(params => {
      this.idClient = +params.get('idClient');
    
      
      this.paticipantService.getExhibitor(this.idClient).subscribe(result => {
        this.client = result;
        // this.openContract();
      })
      this.findInvoices(this.idClient);
 
    });
  }


 
 
  fileURL: string;
 
  updateInvoice(idInvoice: number) {
    //console.log("id invoice"+idInvoice);
    
    this.findInvoicesChanged(this.idClient, idInvoice);
   }

  deleteInoice() {
    if (window.confirm("Are you sure")) {
      this.factureService.remove(this.selectedInvoice).subscribe(resul => {
 
        this.findInvoices(this.idClient);
        this.factureService.nextEditInvoice(this.selectedInvoice)
      });
    }
  }

  selectRow(invoice: Facture) {
   
    //console.log('result1invoice '+invoice.idfacture);
    this.selectedInvoice = invoice;
    this.factureService.selectInvoice(this.selectedInvoice);
  }
 editInvoice(invoice:Facture){
  // this.selectRow(invoice)
this.editVisible=true;


 } 
 
  
  classerFacture(classer: boolean) {
    this.selectedInvoice.aclasser = classer;
    this.factureService.save(this.selectedInvoice).subscribe(result => {

    })
  }




  
  createNew() {
    let facture = new Facture();
    facture.type = 'Facture';
    facture.datefacture = new Date();
    facture.dateenvoicontrat = null;
    facture.client = this.client;

    facture.utilisateurs = JSON.parse(localStorage.getItem('currentUser')) ;
    facture.prospectprospectId = this.client.prospectId;
    this.contactService.findContactsByProspect(facture.prospectprospectId.prospectId).subscribe(result => {
      if (result && result.length != 0) {


        facture.contactcontactId = result[0];
        facture.devise = 'dzd';

        this.factureService.create(facture).subscribe(result => {
     
          this.findInvoices(this.idClient);

        });
      }
      else {
        window.alert("Veuillez ajouter des contacts au client " + this.client.prospectId.raisonSocial)
      }
    });


  }
  avoirFactureSelected() {
    this.avoirFacture(this.selectedInvoice);
  }
  avoirFacture(facture: Facture) {
    if (!facture.numeroFiche) {
      window.alert('La factures n\'est pas  validé');
    }

    else {
      this.factureService.avoirFacture(facture).subscribe(result => {
        //    this.showMessageSuccess("Validé ", JSON.parse(JSON.stringify(result))._body);
        this.findInvoices(this.idClient);

        this.selectedInvoice = result;
        this.factureService.selectInvoice(result);
        // this.getFactures(this.selectedClient.prospectId);
      });
    }

  }
  findInvoicesChanged(idParticipant: number, idInvoice: number) {
    this.factureService.findByParticipant(idParticipant).subscribe(result => {
      this.invoices = result;
    
      this.dataSource = new MatTableDataSource(result);
      if (result) {
      

        result.forEach(element => {
          //console.log("idel---1"+element.idfacture);
          if (element.idfacture === idInvoice)
          {
            //console.log("el1");
            
             this.selectRow(element);
            
          }
           
        });
      }
    })
  }
  findInvoices(idParticipant: number) {
    this.factureService.findByParticipant(idParticipant).subscribe(result => {
      this.invoices = result;
      this.dataSource = new MatTableDataSource(result);
      if (result) {
        //console.log("this.idfacture"+this.idfacture);
        
 if (result.length == 1) {
          this.selectRow(result[0]);
        }
      }
    })
  }

}
